import React from 'react';
import {
  AddressList,
  AddressListItem,
  AddressListItemIframe,
  AddressListItemText,
  ContactsList,
  ContactsListItem,
  ContactsListItemLink,
  ContactsListItemLinkBox,
  FacebookIcon,
  Footer,
  FooterBox,
  HoursList,
  HoursListItem,
  HoursListItemText,
  InstagramIcon,
} from './Footer.styled';
import Logo from '../../images/logo.png';
import { LogoBox, LogoImg } from 'components/Header/Header.styled';
import { useTranslation } from 'react-i18next';

export const FooterComp = React.forwardRef((props, ref) => {
  const { t } = useTranslation();

  return (
    <Footer ref={ref}>
      <FooterBox>
        <LogoBox href="/" aria-label="logo company">
          <LogoImg src={Logo} alt="logo" />
        </LogoBox>
        <HoursList>
          <HoursListItem>
            <HoursListItemText>{t('Mo - Ruhetag')}</HoursListItemText>
          </HoursListItem>
          <HoursListItem>
            <HoursListItemText>{t('Di')} - 9:30-22:00</HoursListItemText>
          </HoursListItem>
          <HoursListItem>
            <HoursListItemText>{t('Mi')} - 9:30-22:00</HoursListItemText>
          </HoursListItem>
          <HoursListItem>
            <HoursListItemText>{t('Do')} - 9:30-22:00</HoursListItemText>
          </HoursListItem>
          <HoursListItem>
            <HoursListItemText>{t('Fr')} - 9:30-22:00</HoursListItemText>
          </HoursListItem>
          <HoursListItem>
            <HoursListItemText>{t('Sa')} - 9:30-22:00</HoursListItemText>
          </HoursListItem>
          <HoursListItem>
            <HoursListItemText>{t('So')} - 9:30-14:30</HoursListItemText>
          </HoursListItem>
        </HoursList>

        {/* Contacts */}
        <ContactsList>
          <ContactsListItem>
            <ContactsListItemLink href="tel:+43284224165">
              02842/24165
            </ContactsListItemLink>
          </ContactsListItem>
          <ContactsListItem>
            <ContactsListItemLink href="mailto:oswald.waidhofen-thaya@hotmail.com">
              oswald.waidhofen-thaya@hotmail.com
            </ContactsListItemLink>
          </ContactsListItem>

          <ContactsListItemLinkBox>
            <ContactsListItem style={{ marginRight: 10 }}>
              <ContactsListItemLink
                href="https://www.instagram.com/oswaldhokko?igsh=MXFucGU5YzcwZmw4ZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </ContactsListItemLink>
            </ContactsListItem>

            <ContactsListItem>
              <ContactsListItemLink
                href="https://www.facebook.com/share/1A45Hv7sZm/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </ContactsListItemLink>
            </ContactsListItem>
          </ContactsListItemLinkBox>
        </ContactsList>
      </FooterBox>
      <AddressList>
        <AddressListItem>
          <AddressListItemText>{t('Adresse')}</AddressListItemText>
          <AddressListItemText>
            Oswald, 3830 Waidhofen an der Thaya
          </AddressListItemText>
        </AddressListItem>
        <AddressListItem>
          <a
            href="https://www.google.com/maps?q=Oswald,3830+Waidhofen+an+der+Thaya"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AddressListItemIframe
              title="Google Map"
              src="https://www.google.com/maps?q=Oswald,3830+Waidhofen+an+der+Thaya&output=embed"
              allowFullScreen
            ></AddressListItemIframe>
          </a>
        </AddressListItem>
      </AddressList>
    </Footer>
  );
});
